import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  G4_P1_S1_Title: {
    id: `guide04.page01.slide01.title`,
  },
  G4_P1_S1_Description: {
    id: `guide04.page01.slide01.description`,
  },
  G4_P1_S1_Thanks: {
    id: `guide04.page01.slide01.thanks`,
  },
  G4_P1_S2_Title: {
    id: `guide04.page01.slide02.title`,
  },
  G4_P1_S2_Item1: {
    id: `guide04.page01.slide02.item1`,
  },
  G4_P1_S2_Item2: {
    id: `guide04.page01.slide02.item2`,
  },
  G4_P1_S2_Item3: {
    id: `guide04.page01.slide02.item3`,
  },
  G4_P1_S3_Title: {
    id: `guide04.page01.slide03.title`,
  },
  G4_P1_S3_Item1: {
    id: `guide04.page01.slide03.item1`,
  },
  G4_P1_S3_Item2: {
    id: `guide04.page01.slide03.item2`,
  },
  G4_P1_S3_Item2_1: {
    id: `guide04.page01.slide03.item2_1`,
  },
  G4_P1_S3_Item2_2: {
    id: `guide04.page01.slide03.item2_2`,
  },
  G4_P1_S3_Item3: {
    id: `guide04.page01.slide03.item3`,
  },
  G4_P1_S3_Item4: {
    id: `guide04.page01.slide03.item4`,
  },
  G4_P1_S3_Item5: {
    id: `guide04.page01.slide03.item5`,
  },
});
